module.exports = __webpack_public_path__ + "static/media/sl.af0884d4.svg";